import { render } from "./SyncSidebar.vue?vue&type=template&id=eca974c8&scoped=true"
import script from "./SyncSidebar.vue?vue&type=script&lang=js"
export * from "./SyncSidebar.vue?vue&type=script&lang=js"

import "./SyncSidebar.vue?vue&type=style&index=0&id=eca974c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eca974c8"]])

export default __exports__